import svg1 from "../../assets/images/svg-1.svg";

export const contactData = {
  id: "contact",
  lightBg: true,
  lightText: false,
  lightTextDesc: true,
  topLine: "Contact",
  headline: "This is the Headline contact",
  description: "Have any questions or just want to say hello?",
  buttonLabel: "Get started",
  imgStart: false,
  isVid: false,
  img: svg1,
  alt: "me",
  dark: true,
  primary: true,
  darkText: false,
};
